import { useTranslation } from 'react-i18next';
import { ExternalScheduleMaterialInputsProps } from './types';
import { FormItemWrapper } from '@components/ui/form/itemWrapper';
import { Input } from '@components/ui/form/input';
import React from 'react';

export const ExternalScheduleMaterialInputs = ({
  material,
}: ExternalScheduleMaterialInputsProps) => {
  const { t } = useTranslation('app', { keyPrefix: 'forms' });

  return (
    <div className="grid grid-cols-2 gap-4">
      {material?.options?.map((option) => {
        return (
          <React.Fragment key={option.id}>
            {option.includeEstimated && (
              <FormItemWrapper
                label={t('estimatedUnits.label', { name: option?.name, unit: option?.unit || '' })}
                className="col-start-1">
                <Input
                  title={option?.estimatedQuantity}
                  value={option?.estimatedQuantity || ''}
                  disabled
                  readOnly
                  rightAlignValue={option.valueType === 'number' && !!option.unit}
                  suffixElement={<span>{option.unit}</span>}
                />
              </FormItemWrapper>
            )}
            <FormItemWrapper
              label={
                option.includeEstimated
                  ? t('finalUnits.label', { name: option?.name, unit: option?.unit || '' })
                  : `${option?.name} ${option?.unit}`
              }
              className={option.includeEstimated ? 'col-start-2' : 'col-start-1 col-end-3'}>
              <Input
                title={option.finalQuantity}
                value={option?.finalQuantity || ''}
                disabled
                readOnly
                rightAlignValue={option.valueType === 'number' && !!option.unit}
                suffixElement={<span>{option.unit}</span>}
              />
            </FormItemWrapper>
          </React.Fragment>
        );
      })}
    </div>
  );
};
